import { StatusEnum } from "@gtpl/shared-models/common-models";
import { EntityRepository, Repository } from "typeorm";
import { SoInvoiceDetails } from "../sale-invoice-details.entity";
import appSettings from "apps/services/config";
import { InvoiceRequest, ShippedDateRequest } from "libs/shared-models/sale-management/src/lib/sale-order/invoice-reqest";
import {PortOfEntryInput } from "libs/shared-models/sale-management/src/lib/sale-order/port-of-entries-input";


const getPortOfEntryName = (portOfEntryValue) => {
    const portOfEntry = PortOfEntryInput.find(entry => entry.value === portOfEntryValue);
    return portOfEntry ? portOfEntry.name : null;
};
@EntityRepository(SoInvoiceDetails)
export class SoInvoiceRepository extends Repository<SoInvoiceDetails> {
    async getPoNumbers() {
        const soItemEntity = await this.createQueryBuilder("so_invoice_details")
            .select('so_invoice_details.po_number as poNumber,saleOrderInfo.status,saleOrderInfo.sale_order_id as saleOrderId')
            .leftJoin('so_invoice_details.saleOrderInfo', 'saleOrderInfo')
            .where(`saleOrderInfo.status in ('${StatusEnum.OPEN}','${StatusEnum.IN_PROGRESS}')`)
            .getRawMany();
        return soItemEntity;
    }

    async getPendingOrdersReport(req: InvoiceRequest) {
        // SQL query to get the necessary data
        let query = `SELECT so.po_number as PoNumber,DATE(so.invoice_date) AS poDate,
                     ec.end_customer_name as customerName, mb.brand_name as brandName,
                     co.country_name as countryName, soi.varient_id,
                     skc.short_code as variety, pm.packing_method_name as packMethodName,
                     soi.min_grade_id as minGrade, soi.max_grade_id as maxGrade,
                     soi.cases as noOfCases, soi.net_weight as netWeight,
                     soi.unitPrice as rateKg, soi.net_amount as amount,DATE
                     (so.act_edl_date)  as shipmentDate,
                      so.port_of_entry,c.invoice_number as invoiceNumber,DATE
                      (c.invoice_date) as invoiceDate,
                      so.processing_unit,uc.plant_code as unitName,u.company as companyName,uc.company_id as companyId,so.factoryId,d.destination_name as destination
                     FROM so_invoice_details so
                     LEFT JOIN sale_order_track sot ON sot.sale_order_id=so.sale_order_id
                     LEFT JOIN ${appSettings.masters_db}.end_customers ec ON so.end_customer_id = ec.end_customer_id
                      LEFT JOIN sale_order_items soi ON so.sale_order_id = soi.sale_order_id
                     LEFT JOIN ${appSettings.masters_db}.master_brands mb ON mb.master_brand_id = soi.master_brand_id
                     LEFT JOIN ${appSettings.masters_db}.countries co ON so.country_id = co.country_id
                     LEFT JOIN ${appSettings.masters_db}.sku_codes skc ON skc.sku_code_id = soi.varient_id
                     LEFT JOIN ${appSettings.masters_db}.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
                     LEFT JOIN customer_invoice c ON c.sale_order_id = so.sale_order_id and c.is_active =1
                     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = so.processing_unit
                     LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id=so.factoryId
                     LEFT JOIN ${appSettings.masters_db}.destination d ON d.destination_id = so.destination
                     LEFT JOIN sale_order s ON s.sale_order_id = so.sale_order_id

                     WHERE sot.container_status != 'SHIPPED' AND  s.so_process_type = 'MTO' and s.status !='CANCELLED'`;

        if (req.poNumber) {
            query += ` AND so.po_number = '${req.poNumber}'`
        }

        if (req.poDateStartDate !== undefined) {
            query += ` AND STR_TO_DATE(so.invoice_date, '%Y-%m-%d') BETWEEN '${req.poDateStartDate}' AND '${req.poDateEndDate}'`
        }
        if (req.poDateStartDate !== undefined) {
            query += ` AND STR_TO_DATE(so.invoice_date, '%Y-%m-%d') BETWEEN '${req.poDateStartDate}' AND '${req.poDateEndDate}'`
        }
        if (req.isInvoiced === "YES") {
            query += ` AND c.invoice_number Is Not NULL`
        }
        if (req.isInvoiced === "NO") {
            query += ` AND c.invoice_number IS NULL`
        }
        if (req.unitId && req.unitId != 5) {
            query = query + ' and so.processing_unit = ' + req.unitId;
        }
        if (req.shipmentDateStartDate !== undefined) {
            query += ` AND STR_TO_DATE(so.act_edl_date, '%Y-%m-%d') BETWEEN '${req.shipmentDateStartDate}' AND '${req.shipmentDateEndDate}'`
        }
        if (req.companyId) {
            query += ` AND so.factoryId = '${req.companyId}'`
        }
        // Execute the query and get the results
        const result = await this.query(query);

        // Process the results to build the parent-child structure
        let report = {};

        result.forEach(row => {
            const {
                PoNumber, poDate, customerName, brandName, countryName, shipmentDate,
                varient_id, variety, packMethodName, minGrade, maxGrade, noOfCases, netWeight, rateKg, amount, port_of_entry,invoiceNumber,invoiceDate,unitName,companyName,destination
            } = row;

            const noOfCasesNum = Number(noOfCases);
            const netWeightNum = parseFloat(netWeight);
            const amountNum = parseFloat(amount);
            const portOfEntryName = getPortOfEntryName(port_of_entry);

            // Initialize the parent object if it doesn't exist
            if (!report[PoNumber]) {
                report[PoNumber] = {
                    PoNumber,
                    poDate,
                    customerName,
                    brandName,
                    countryName,
                    shipmentDate,
                    portOfEntryName,
                    totalAmount: 0,
                    totalNoOfCases: 0,
                    totalNetWeight: 0,
                    invoiceNumber,
                    invoiceDate,
                    unitName,
                    companyName,
                    destination,
                    items: []
                };
            }
            report[PoNumber].totalAmount += amountNum;
            report[PoNumber].totalNoOfCases += noOfCasesNum;
            report[PoNumber].totalNetWeight += netWeightNum;

            // Add the child item to the parent's items array
            report[PoNumber].items.push({
                varient_id,
                variety,
                packMethodName,
                minGrade,
                maxGrade,
                noOfCases: noOfCasesNum,
                netWeight: netWeightNum.toFixed(3),
                rateKg,
                amount: amountNum.toFixed(2)
            });
        });

        // Convert the report object to an array if needed
        const reportArray = Object.values(report);
        return reportArray;
    }

    async getShippedOrdersReport(req: ShippedDateRequest) {
        // SQL query to get the necessary data
        let query = `SELECT so.po_number as PoNumber, so.invoice_date as poDate,
                     ec.end_customer_name as customerName, mb.brand_name as brandName,
                     co.country_name as countryName, soi.varient_id,
                     skc.short_code as variety, pm.packing_method_name as packMethodName,
                     soi.min_grade_id as minGrade, soi.max_grade_id as maxGrade,
                     soi.cases as noOfCases, soi.net_weight as netWeight,
                     soi.unitPrice as rateKg, soi.net_amount as amount, c.shipped_onboard_date  as shipmentDate,
                     pt.payment_terms_name as paymentTerms,
                     ci.invoice_number as invoiceNumber,
                     ci.invoice_date as invoiceDate,
                     so.port_of_entry,
                     so.processing_unit,uc.plant_code as unitName,u.company as companyName,uc.company_id as companyId,so.factoryId,
                     d.destination_name as destinationName
                     FROM so_invoice_details so
                     LEFT JOIN sale_order_track sot ON sot.sale_order_id=so.sale_order_id
                     LEFT JOIN sale_order_items soi ON so.sale_order_id = soi.sale_order_id
                     LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id=so.sale_order_id
                     LEFT JOIN ${appSettings.masters_db}.end_customers ec ON so.end_customer_id = ec.end_customer_id
                     LEFT JOIN ${appSettings.masters_db}.master_brands mb ON mb.master_brand_id = soi.master_brand_id
                     LEFT JOIN ${appSettings.masters_db}.countries co ON so.country_id = co.country_id
                     LEFT JOIN ${appSettings.masters_db}.sku_codes skc ON skc.sku_code_id = soi.varient_id
                     LEFT JOIN ${appSettings.masters_db}.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
                     LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id  =  so.pay_terms_id
                     LEFT JOIN customer_invoice ci ON ci.sale_order_id = so.sale_order_id and ci.is_active =1
                     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = so.processing_unit
                     LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id=so.factoryId
                     LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=so.destination
                     WHERE sot.container_status = 'SHIPPED'`;

        if (req.poNumber) {
            query += ` AND so.po_number = '${req.poNumber}'`;
        }

        if (req.shipmentDateStartDate !== undefined) {
            query += ` AND STR_TO_DATE(c.shipped_onboard_date, '%Y-%m-%d') BETWEEN '${req.shipmentDateStartDate}' AND '${req.shipmentDateEndDate}'`
        }
        if (req.invoiceStartDate !== undefined) {
            query += ` AND STR_TO_DATE(ci.invoice_date, '%Y-%m-%d') BETWEEN '${req.invoiceStartDate}' AND '${req.invoiceEndDate}'`
        }
        if (req.unitId && req.unitId != 5) {
            query = query + ' and so.processing_unit = ' + req.unitId;
        }

        if (req.companyId) {
            query += ` AND so.factoryId = '${req.companyId}'`
        }
        // Execute the query and get the results
        const result = await this.query(query);

        // Process the results to build the parent-child structure
        let report = {};

        result.forEach(row => {
            const {
                PoNumber, poDate, customerName, brandName, countryName, shipmentDate,
                varient_id, variety, packMethodName, minGrade, maxGrade, noOfCases, netWeight, rateKg, amount, paymentTerms, invoiceNumber, invoiceDate,port_of_entry,unitName,companyName,destinationName
            } = row;

            const noOfCasesNum = Number(noOfCases);
            const netWeightNum = parseFloat(netWeight);
            const amountNum = parseFloat(amount);
            const portOfEntryName = getPortOfEntryName(port_of_entry);

            // Initialize the parent object if it doesn't exist
            if (!report[PoNumber]) {
                report[PoNumber] = {
                    PoNumber,
                    poDate,
                    customerName,
                    brandName,
                    countryName,
                    shipmentDate,
                    paymentTerms,
                    invoiceNumber,
                    invoiceDate,
                    portOfEntryName,
                    totalAmount: 0,
                    totalNoOfCases: 0,
                    totalNetWeight: 0,
                    unitName,
                    companyName,
                    destinationName,
                    items: []
                };
            }
            report[PoNumber].totalAmount += amountNum;
            report[PoNumber].totalNoOfCases += noOfCasesNum;
            report[PoNumber].totalNetWeight += netWeightNum;

            // Add the child item to the parent's items array
            report[PoNumber].items.push({
                varient_id,
                variety,
                packMethodName,
                minGrade,
                maxGrade,
                noOfCases: noOfCasesNum,
                netWeight: netWeightNum.toFixed(3),
                rateKg,
                amount: amountNum.toFixed(2)
            });
        });

        // Convert the report object to an array if needed
        const reportArray = Object.values(report);

        return reportArray;
    }


    async getDistinctPoNumbers(req: {unitId?: number}) {
        let query=`SELECT sid.po_number as PoNumber FROM so_invoice_details sid
        LEFT JOIN sale_order_track sot ON sot.sale_order_id=sid.sale_order_id
        WHERE sot.container_status = 'SHIPPED' AND sid.processing_unit = ${req.unitId}`
        const result = await this.query(query);
                return result;
    }





    async getBuyerWiseOrdersReport(req: InvoiceRequest) {
        // SQL query to get the necessary data
        let query = `SELECT  sod.po_number AS poNumber,
        sod.invoice_date AS poDate,
        CONCAT(c.certificate_name, ' ', COALESCE(spd.rating, '')) AS certificateDetails,
        uc.unit_name AS company,sod.processing_unit,uc.plant_code as unitName,uc.unit_code_id,uc.company,
        ec.end_customer_name AS buyerName,
        mb.brand_name AS brand,
        CASE 
        WHEN COUNT(*) > 1 THEN 'Mixed'
        ELSE CONCAT(soi.min_grade_id, '/', soi.max_grade_id)
    END AS grade,
         GROUP_CONCAT(DISTINCT CONCAT(soi.min_grade_id, '/', soi.max_grade_id) SEPARATOR ', ') AS gradeList,
         soi.cases AS noOfCases,
         pm.packing_method_name AS packMethodName,
         sod.act_edl_date  AS shipmentDate,
          co.country_name AS countryName,
          d.destination_name AS destination,
          CASE 
        WHEN sot.container_status = 'SHIPPED' THEN 'SHIPPED'
        ELSE 'PENDING'
    END AS shipmentTerms,
            GROUP_CONCAT(DISTINCT CONCAT(ft.food_type_code,vaone.code, vatwo.code,vathree.code, '-', vafour.code) SEPARATOR ', ') AS products

        
                  FROM so_invoice_details sod
                  LEFT JOIN so_po_details spd ON sod.sale_order_id = spd.sale_order_id
                  LEFT JOIN ${appSettings.masters_db}.certificates c ON c.certificate_id = spd.certification_id
                  LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = sod.factoryId
                  LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = sod.end_customer_id
                  LEFT JOIN sale_order_items soi ON soi.sale_order_id = sod.sale_order_id
                  LEFT JOIN ${appSettings.masters_db}.master_brands mb ON mb.master_brand_id =soi.master_brand_id
                  LEFT JOIN ${appSettings.masters_db}.sku_codes skc ON skc.sku_code_id = soi.varient_id
                  LEFT JOIN ${appSettings.masters_db}.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
                  LEFT JOIN ${appSettings.masters_db}.countries co ON sod.country_id = co.country_id
                  LEFT JOIN ${appSettings.masters_db}.destination d ON sod.destination = d.destination_id
                  LEFT JOIN sale_order_track sot ON sot.sale_order_id=sod.sale_order_id
                  LEFT JOIN ${appSettings.masters_db}.food_types ft ON ft.food_type_id = soi.food_type_id
                  LEFT JOIN ${appSettings.masters_db}.value_addition_one_types vaone ON vaone.value_addition_one_id = soi.value_addition_one_id
                  LEFT JOIN ${appSettings.masters_db}.value_addition_two_types vatwo ON vatwo.value_addition_two_id = soi.value_addition_two_id
                  LEFT JOIN ${appSettings.masters_db}.value_addition_three_types vathree ON  vathree.value_addition_three_id = soi.value_addition_three_id
                  LEFT JOIN ${appSettings.masters_db}.value_addition_four_types vafour ON vafour.value_addition_four_id = soi.value_addition_four_id
                   WHERE 1=1`;

    // Add date filter condition if specified
    if (req.poDateStartDate !== undefined && req.poDateEndDate !== undefined) {
        query += ` AND STR_TO_DATE(sod.invoice_date, '%Y-%m-%d') BETWEEN '${req.poDateStartDate}' AND '${req.poDateEndDate}'`;
    }
    if (req.shipmentDateStartDate !== undefined && req.shipmentDateEndDate !== undefined) {
        query += ` AND STR_TO_DATE(sod.act_edl_date, '%Y-%m-%d') BETWEEN STR_TO_DATE('${req.shipmentDateStartDate}', '%Y-%m-%d') AND STR_TO_DATE('${req.shipmentDateEndDate}', '%Y-%m-%d') `;
    }    
    if (req.poNumber) {
        query += ` AND sod.po_number = '${req.poNumber}'`;
    }
    if(req.unitId && req.unitId !=5){
        query += ` and sod.processing_unit = '${req.unitId}'`
      }
      if(req.companyId){
        query += ` and sod.factoryId = "${req.companyId}"`
      }
    query += `
 
                GROUP BY 
                    soi.food_type_id,
                    soi.value_addition_one_id,
                    soi.value_addition_two_id,
                    soi.value_addition_three_id,
                    soi.value_addition_four_id,
                    sod.po_number

                    ORDER BY 
                     sot.container_status
                    `;
        const result = await this.query(query);
        return result;
    }

}
